import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Params, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {PageEvent} from '@angular/material/paginator';
import {Sort} from '@angular/material/sort';
import {Order} from '../../../domain/order';
import {AssignOrderUserComponent} from '../assign-user-dialog/assign-order-user.component';
import {PopupService} from '../../../component/popup.service';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmationDialogComponent} from '../../../component/confirmation-dialog/confirmation-dialog.component';
import {RequestExecutor} from '../../../util/request-executor';
import {MessageService} from '../../../component/message.service';
import {OrderTableComponent} from '../order-table/order-table.component';

@Component({
  selector: 'app-assign-orders',
  templateUrl: './assign-orders.component.html',
  styleUrl: './assign-orders.component.css',
  standalone: false
})
export class AssignOrdersComponent implements OnInit {
  totalOrderCount: number;
  orders: Order[];
  currentPage = 0;
  currentSortBy: string = 'ExternalId';
  currentSortDirection: string = 'Desc';
  currentPageSize = 20;
  progress = false;

  selectedOrders: Order[] = [];

  multipleSelectEnabled = false;

  @ViewChild("orderTable")
  orderTable: OrderTableComponent

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private popupService: PopupService,
    private dialog: MatDialog,
    private request: RequestExecutor,
    private messageService: MessageService) {
  }

  ngOnInit() {
    this.initValue();

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.initValue();
      });

    this.route.queryParams.subscribe((params: Params) => {
      if (params['page'] !== undefined) {
        this.currentPage = +params['page'] - 1;
      } else {
        this.currentPage = 0;
      }

      this.currentPageSize = params['pageSize'] == null ? 20 : params['pageSize'];
    });
  }

  private initValue() {
    this.totalOrderCount = this.route.snapshot.data['data'].TotalOrderCount;
    this.orders = this.route.snapshot.data['data'].Orders;
  }

  changePage(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.currentPageSize = event.pageSize;

    this.navigateWithNewParameters();
  }

  navigateWithNewParameters() {
    this.clearSelection();

    const params = {
      page: this.currentPage + 1,
      pageSize: this.currentPageSize,
      sortBy: this.currentSortBy,
      sortDirection: this.currentSortDirection
    };

    this.router.navigate(['/admin/orders'], {queryParams: params});
  }

  sortChanged(sort: Sort) {
    this.currentSortBy = sort.active;
    this.currentSortDirection = sort.direction === 'desc' ? 'Desc' : 'Asc';

    this.navigateWithNewParameters();
  }

  protected toggleMultipleSelect() {
    this.multipleSelectEnabled = !this.multipleSelectEnabled;

    this.clearSelection();
  }

  protected clearSelection() {
    this.selectedOrders = [];

    this.orderTable.clearSelection();
  }

  protected assignSelectedOrders() {
    this.assignOrders(this.selectedOrders);
  }

  protected unassignSelectedOrders() {
    this.queryUnassignOrders(this.selectedOrders);
  }

  queryUnassignOrders(orders: Order[]) {
    let dialogRef = this.dialog.open(ConfirmationDialogComponent);

    dialogRef.componentInstance.title = 'Bekreft endring';
    dialogRef.componentInstance.description = 'Vil du fjerne tildeling av turen' + (orders.length > 1 ? 'e' : '') + '?';

    dialogRef.afterClosed()
      .subscribe(value => {
        if (value) {
          this.unassignOrders(orders.map(s => s.Id));
        }
      });
  }

  unassignOrders(orderIds: string[]) {
    this.progress = true;

    this.request.post('/order/unassign/user/batch', {OrderIds: orderIds})
      .then(() => {
        this.messageService.showBottomSuccessSnackBar('Tildeling ble fjernet for turen' + (orderIds.length > 1 ? 'e' : ''));

        this.navigateWithNewParameters();
      })
      .catch(error => {
        if (error.status == 401) {
          this.router.navigate(['login']);
        } else {
          this.messageService.showBottomErrorSnackBar('Kunne ikke fjerne tildeling av turen' + (orderIds.length > 1 ? 'e' : ''));
        }
      })
      .finally(() => this.progress = false);
  }

  protected onSelectionToggled(order: Order) {
    let existing = this.selectedOrders.findIndex(o => o.Id === order.Id);

    console.log(order)
    console.log(existing)

    if (existing === -1) {
      this.selectedOrders.push(order);
    } else {
      this.selectedOrders.splice(existing, 1);
    }

    console.log(this.selectedOrders)
  }

  protected assignOrders(orders: Order[]) {
    this.popupService.openFromComponent(AssignOrderUserComponent, {orderIds: orders.map(o => o.Id)}, {dynamicHeight: true})
      .subscribe(() => {
        this.navigateWithNewParameters();
      });
  }
}
